var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "productTypeDialog",
          attrs: {
            "close-on-click-modal": false,
            "destroy-on-close": true,
            "custom-class": "planWordDialog",
            "append-to-body": true,
            title: "生成操作确认单",
            visible: _vm.collectionShow,
            width: "45%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.collectionShow = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "Dialog-top" },
            [
              _c(
                "el-form",
                {
                  ref: "collectionRequest",
                  attrs: {
                    rules: _vm.rules,
                    model: _vm.collectionRequest,
                    "label-width": "80px",
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "collection-line" },
                    [
                      _c("h3", [_vm._v("确认项目及收费金额")]),
                      _c(
                        "p",
                        { staticClass: "colletion-p" },
                        [
                          _c(
                            "el-radio",
                            {
                              attrs: { label: 1 },
                              on: { change: _vm.changeType },
                              model: {
                                value: _vm.colletionType,
                                callback: function ($$v) {
                                  _vm.colletionType = $$v
                                },
                                expression: "colletionType",
                              },
                            },
                            [
                              _vm._v(
                                "全款" +
                                  _vm._s(
                                    _vm.totalPayPrice != ""
                                      ? "(" + _vm.totalPayPrice + "¥)"
                                      : ""
                                  )
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "p",
                        { staticClass: "colletion-p" },
                        [
                          _c(
                            "el-radio",
                            {
                              attrs: { label: 2 },
                              on: { change: _vm.changeType },
                              model: {
                                value: _vm.colletionType,
                                callback: function ($$v) {
                                  _vm.colletionType = $$v
                                },
                                expression: "colletionType",
                              },
                            },
                            [_vm._v("按项目")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "p",
                        {
                          staticClass: "colletion-p",
                          staticStyle: { "padding-left": "60px" },
                        },
                        [
                          _c(
                            "el-checkbox-group",
                            {
                              on: { change: _vm.chooseTypeList },
                              model: {
                                value: _vm.checkList,
                                callback: function ($$v) {
                                  _vm.checkList = $$v
                                },
                                expression: "checkList",
                              },
                            },
                            _vm._l(
                              _vm.stateTotalPayPrice,
                              function (item, index) {
                                return _c(
                                  "span",
                                  { key: index },
                                  [
                                    item.price > 0
                                      ? _c(
                                          "el-checkbox",
                                          { attrs: { label: item.state } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.stockTypeMap[item.state]
                                                  .typeName
                                              ) +
                                                "（" +
                                                _vm._s(item.price) +
                                                "¥）"
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              }
                            ),
                            0
                          ),
                        ],
                        1
                      ),
                      _c(
                        "p",
                        { staticClass: "colletion-p" },
                        [
                          _c(
                            "el-radio",
                            {
                              attrs: { label: 3 },
                              on: { change: _vm.changeType },
                              model: {
                                value: _vm.colletionType,
                                callback: function ($$v) {
                                  _vm.colletionType = $$v
                                },
                                expression: "colletionType",
                              },
                            },
                            [_vm._v("按具体产品")]
                          ),
                          !_vm.collectionRequest.id
                            ? _c(
                                "el-link",
                                {
                                  attrs: { type: "success" },
                                  on: { click: _vm.chooseProduct },
                                },
                                [_vm._v("选择产品")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "p",
                        { staticClass: "colletion-p" },
                        [
                          _c(
                            "el-radio",
                            {
                              attrs: { label: 4 },
                              on: { change: _vm.changeType },
                              model: {
                                value: _vm.colletionType,
                                callback: function ($$v) {
                                  _vm.colletionType = $$v
                                },
                                expression: "colletionType",
                              },
                            },
                            [_vm._v("自定义")]
                          ),
                        ],
                        1
                      ),
                      _vm.colletionType == 4
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "收费款项",
                                prop: "chargingContent",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { type: "textarea" },
                                model: {
                                  value: _vm.collectionRequest.chargingContent,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.collectionRequest,
                                      "chargingContent",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "collectionRequest.chargingContent",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-form-item",
                        { attrs: { label: "收费金额", prop: "feeAmount" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "200px" },
                            attrs: {
                              type: "number",
                              disabled: _vm.collectionRequest.id,
                            },
                            on: { change: _vm.changePrice },
                            model: {
                              value: _vm.collectionRequest.feeAmount,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.collectionRequest,
                                  "feeAmount",
                                  $$v
                                )
                              },
                              expression: "collectionRequest.feeAmount",
                            },
                          }),
                          _c("currency-autocomplete", {
                            attrs: {
                              obj: _vm.collectionRequest,
                              sizeType: "medium",
                              styleStr: "margin-left: 0.1rem;",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "p",
                        { staticClass: "colletion-p" },
                        [
                          _c(
                            "el-radio",
                            {
                              attrs: { label: 1, disabled: _vm.disabled },
                              model: {
                                value: _vm.payOrder,
                                callback: function ($$v) {
                                  _vm.payOrder = $$v
                                },
                                expression: "payOrder",
                              },
                            },
                            [_vm._v("客人缴费后系统自动下采购订单")]
                          ),
                          _c(
                            "el-radio",
                            {
                              attrs: { label: 2, disabled: _vm.disabled },
                              model: {
                                value: _vm.payOrder,
                                callback: function ($$v) {
                                  _vm.payOrder = $$v
                                },
                                expression: "payOrder",
                              },
                            },
                            [_vm._v("客人缴费后，我自己手动下产品采购订单")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "collection-line" },
                    [
                      _c("h3", [_vm._v("费用说明")]),
                      _vm.colletionType == 4
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "包含" } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.collectionRequest.contain,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.collectionRequest,
                                      "contain",
                                      $$v
                                    )
                                  },
                                  expression: "collectionRequest.contain",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.colletionType == 4
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "退改" } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.collectionRequest.returnMsg,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.collectionRequest,
                                      "returnMsg",
                                      $$v
                                    )
                                  },
                                  expression: "collectionRequest.returnMsg",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.colletionType == 4
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "不含" } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.collectionRequest.excluding,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.collectionRequest,
                                      "excluding",
                                      $$v
                                    )
                                  },
                                  expression: "collectionRequest.excluding",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "服务提供方",
                            prop: "serviceProvider",
                          },
                        },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.collectionRequest.serviceProvider,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.collectionRequest,
                                  "serviceProvider",
                                  $$v
                                )
                              },
                              expression: "collectionRequest.serviceProvider",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "联系人", prop: "contacts" } },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.collectionRequest.contacts,
                              callback: function ($$v) {
                                _vm.$set(_vm.collectionRequest, "contacts", $$v)
                              },
                              expression: "collectionRequest.contacts",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "collection-line" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "发票说明" } },
                        [
                          _c("el-input", {
                            attrs: { type: "textarea" },
                            model: {
                              value: _vm.collectionRequest.invoiceDescription,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.collectionRequest,
                                  "invoiceDescription",
                                  $$v
                                )
                              },
                              expression:
                                "collectionRequest.invoiceDescription",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.text && _vm.collectionRequest.currency == "￥"
                    ? _c(
                        "div",
                        {
                          staticClass: "collection-line",
                          staticStyle: {
                            display: "flex",
                            "flex-direction": "column",
                          },
                        },
                        [
                          _c("h3", [_vm._v("二维码链接")]),
                          _c("div", { staticClass: "erWeima" }, [
                            _c(
                              "div",
                              { staticClass: "erWeimaBox" },
                              [
                                _c("p", { staticClass: "erWeimaTitle" }, [
                                  _vm._v("小程序付款"),
                                ]),
                                _c("Qr", {
                                  staticStyle: {
                                    "text-align": "center",
                                    display: "flex",
                                    "margin-left": "120px",
                                  },
                                  attrs: {
                                    bgSrc: _vm.bgSrc,
                                    logoSrc: _vm.logoSrc,
                                    text: _vm.text1,
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  !_vm.collectionRequest.id
                    ? _c("div", [
                        !(
                          _vm.user.officialAccount &&
                          _vm.user.officialAccount != ""
                        )
                          ? _c(
                              "div",
                              {
                                staticStyle: {
                                  "margin-top": "0.1rem",
                                  color: "red",
                                },
                              },
                              [
                                _vm._v(
                                  " 您没有绑定公众号，收不到收款订单结果通知，如需提醒通知，请点击"
                                ),
                                _c(
                                  "a",
                                  {
                                    staticStyle: { color: "blue" },
                                    on: { click: _vm.bangding },
                                  },
                                  [_vm._v("绑定")]
                                ),
                                _vm._v("公众号"),
                              ]
                            )
                          : _vm._e(),
                      ])
                    : _vm._e(),
                  _vm.collectionRequest.id
                    ? _c(
                        "el-form-item",
                        { staticClass: "button" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.uodateColletion()
                                },
                              },
                            },
                            [_vm._v("保存")]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.addUndderLine()
                                },
                              },
                            },
                            [_vm._v("生成线下收款")]
                          ),
                          _c(
                            "el-button",
                            {
                              on: {
                                click: function ($event) {
                                  _vm.collectionShow = false
                                },
                              },
                            },
                            [_vm._v("关闭")]
                          ),
                        ],
                        1
                      )
                    : _c(
                        "el-form-item",
                        { staticClass: "button" },
                        [
                          _vm.text == ""
                            ? _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "loading",
                                      rawName: "v-loading.fullscreen.lock",
                                      value: _vm.fullscreenLoading,
                                      expression: "fullscreenLoading",
                                      modifiers: {
                                        fullscreen: true,
                                        lock: true,
                                      },
                                    },
                                  ],
                                  attrs: { type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.submitForm("collectionRequest")
                                    },
                                  },
                                },
                                [_vm._v("立即生成")]
                              )
                            : _vm._e(),
                          _c(
                            "el-button",
                            {
                              on: {
                                click: function ($event) {
                                  _vm.collectionShow = false
                                },
                              },
                            },
                            [_vm._v("关闭")]
                          ),
                        ],
                        1
                      ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c("add-under-line-pay", {
        ref: "addUnderLonePay",
        on: { getList: _vm.getList },
      }),
      _c("official-account", {
        ref: "officialAccount",
        attrs: { tipText: "扫描上方二维码绑定公众号通知", title: "" },
      }),
      _c("budget-detail-dialog", {
        ref: "budgetDetailDialog",
        attrs: { chenckBudget: _vm.chenckBudget },
        on: { chooseProduct: _vm.chooseProductSure },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }